module.exports = __webpack_public_path__ + "img/Feature.9940122f.jpg";